import React from 'react';
import { Route, Routes } from 'react-router';

import styles from './app.scss';
import { RoutePath } from './routes';
import About from './routes/about/About';
import Contact from './routes/contact/Contact';
import Home from './routes/home/Home';
import Projects from './routes/projects/Projects';

type Props = {
  id: string;
};

const App: React.FC<Props> = (props) => {
  return (
    <div id={props.id} data-testid={props.id} className={styles.app}>
      <Routes>
        <Route index path={RoutePath.Index} element={<Home id="home" />} />
        <Route path={RoutePath.Home} element={<Home id="home" />} />
        <Route path={RoutePath.Projects} element={<Projects id="projects" />} />
        <Route path={RoutePath.About} element={<About id="about" />} />
        <Route path={RoutePath.Contact} element={<Contact id="contact" />} />
      </Routes>
    </div>
  );
};

export default App;
